import React, { useEffect, useState } from "react";
import Tooltip from "../Tooltip";

const AddNewItemButton = ({ title, onClick, width = "w-48", disabled = false, onDisabledTooltip = "" }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Tooltip text={onDisabledTooltip} direction={isMobile ? "bottom" : "right"}>
      <button
        onClick={() => {
          if (disabled) {
            return;
          }
          onClick();
        }}
        disabled={disabled}
        className={`h-8 text-start px-4 text-ov-green text-[12px] md:text-[14px] font-semibold hover:bg-ov-green hover:text-white transition-all rounded-lg disabled:opacity-50 disabled:pointer-events-none disabled:text-slate-700`}
      >
        {title}
      </button>
    </Tooltip>
  );
};

export default AddNewItemButton;
